import React, { createContext, useState } from 'react';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
const DynamicThemeProvider = _ref => {
  let {
    children,
    theme
  } = _ref;
  const [mainColor, setMainColor] = useState(null);
  return /*#__PURE__*/React.createElement(DynamicThemeContext.Provider, {
    key: mainColor || 'themeProvider',
    value: {
      mainColor,
      setMainColor
    }
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: createMuiTheme(theme(mainColor))
  }, children));
};
const DynamicThemeContext = /*#__PURE__*/createContext();
DynamicThemeProvider.propTypes = {
  theme: PropTypes.func.isRequired
};
export { DynamicThemeProvider, DynamicThemeContext };